import type { AliasRequestBodyType } from '../../api-types'
import { apiClient } from '@twlvxtwlv/api'

export function serverSideAlias(input: AliasRequestBodyType) {
  return apiClient.post('/api/stats/alias', input)
}
